/** @module ProductSpec/NewFromThemeController */
define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {

	return declare(New, {
		/**
		 * Add ApparelBOMSubtype from the Subtype Dropdown to be used with copyToStyle HParameter(subtype) 
		 * so it can be referenced in the operation but doesn't set the parameter to true so it can be handled
		 * by the framework 
		 */
		toWriterRequest: function() {
			var fd = this.getFormData();
			var theme = fd.getFieldValue("Theme", true);
			var call = this.inherited(arguments);
			call.addParameter("Subtype", xml.ATTR_REF, fd.getFieldValue("Subtype", true));
			return call;
		}
	});
});